export enum ForgotPasswordStep {
  Email = 1,
  Info = 2
};
